import { useQuery } from '@tanstack/react-query';
export const useGetSide = ({ fetchItems, queryId, topicId }) => useQuery({
    queryKey: [queryId, topicId],
    queryFn: fetchItems,
    staleTime: 5 * 60 * 1000,
});
//# sourceMappingURL=useGetSide.js.map